export const INPUT_GRAY = 'gray'
export const INPUT_WHITE = 'white'
